import { USERS } from "../lib/constants/actions";
export const user = (state = {}, action) => {
    switch (action.type) {
        case USERS.GET_USERS_SUCCESS:
            return { ...state, usersList: action.payload }
        case USERS.REPORT_USERS_SUCCESS:
            return { ...state, reportUsers: action.payload }
        case USERS.GET_ADMIN_USERS_SUCCESS:
            return { ...state, adminUsers: action.payload }
        case USERS.USER_PROFILE_SUCCESS:
            return { ...state, userProfile: action.payload }
        case USERS.SUSPEND_ACCOUNT_SUCCESS:
            return { ...state, accountSuspended: action.payload }
        case USERS.UPDATE_PROFILE_SUCCESS:
            return { ...state, profileUpdated: action.payload }
        case USERS.ADD_USER_SUCCESS:
            return { ...state, userAdded: action.payload }
        case USERS.GET_USERS_LOCATIONS_SUCCESS:
            return { ...state, usersLocations: action.payload }

        case USERS.GET_FOLLOWERS_SUCCESS:
            return { ...state, followers: action.payload }

        case USERS.GET_FOLLOWING_SUCCESS:
            return { ...state, following: action.payload }
        case USERS.GET_DELETED_USERS_SUCCESS:
            return { ...state, deletedUsers: action.payload }
        case USERS.CHANGE_APP_PASSWORD_SUCCESS:
            return { ...state, appPasswordChanged: action.payload }
        case USERS.UPDATE_AUTO_FOLLOW_SUCCESS:
            return { ...state, autoFollowSuccess: action.payload }
        case USERS.CHANGE_ADVERTISE_STATUS_SUCCESS:
            return { ...state, advertiseStatusChanged: action.payload }

        default:
            return state;
    }
};




